import PropTypes from "prop-types";
import React from "react";

function Result(_ref) {
  var fields = _ref.fields,
      onClickLink = _ref.onClickLink,
      title = _ref.title,
      url = _ref.url;
  return React.createElement("li", {
    className: "sui-result"
  }, React.createElement("div", {
    className: "sui-result__header"
  }, title && !url && React.createElement("span", {
    className: "sui-result__title",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), title && url && React.createElement("a", {
    className: "sui-result__title sui-result__title-link",
    dangerouslySetInnerHTML: {
      __html: title
    },
    href: url,
    onClick: onClickLink,
    target: "_blank",
    rel: "noopener noreferrer"
  })), React.createElement("div", {
    className: "sui-result__body"
  }, React.createElement("ul", {
    className: "sui-result__details"
  }, Object.keys(fields).map(function (key) {
    return React.createElement("li", {
      key: key
    }, React.createElement("span", {
      className: "sui-result__key"
    }, key), " ", React.createElement("span", {
      className: "sui-result__value",
      dangerouslySetInnerHTML: {
        __html: fields[key]
      }
    }));
  }))));
}

Result.propTypes = {
  fields: PropTypes.object.isRequired,
  onClickLink: PropTypes.func.isRequired,
  title: PropTypes.string,
  url: PropTypes.string
};
export default Result;